import {
  FieldBuilder,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
} from '@zendra/shared';
import { GISREGISTERINCONSISTENCY_PERMISSION } from '../gis-register-inconsistency-only-in-gis/gis-register-inconsistency-only-in-gis.config';
import { Formatters } from 'angular-slickgrid';

FieldBuilder.setNamespace('Geographic');

export const GISREGISTERINCONSISTENCYONLYINZENDRA_FIELDS = [
  FieldBuilder.text('name', 'Entity.GisRegisterInconsistency.Name').readOnly().build(),
  FieldBuilder.number('area', 'Entity.GisRegisterInconsistency.Area')
    .decimal()
    .formatter(Formatters.decimal)
    .readOnly()
    .build(),
];

export const GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG = {
  entityName: 'GisRegisterInconsistencyOnlyInZendra',
  localizationKey: 'Geographic::Entity.GisRegisterInconsistency.OnlyInZendra',
  fields: GISREGISTERINCONSISTENCYONLYINZENDRA_FIELDS,
  permission: GISREGISTERINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
